import React, { lazy, Suspense } from 'react'
import { Route } from 'react-router-dom'
import { ProtectedRoute } from '../components/ProtectedRoute/ProtectedRoute'
import AdminContainer from '../AdminContainer'
import PicCollectionEditer from '../pages/Admin/PicCollectionEditer/PicCollectionEditer'
import PicTasksList from '../pages/Admin/PicCollectionEditer/PicTasksList'
import TaskPicList from '../pages/Admin/PicCollectionEditer/TaskPicList'

const DmApplicationPage = lazy(() => import('../pages/Admin/DmAppilcation/DmAppilcation'))
const SiApplicationPage = lazy(() => import('../pages/Admin/SiApplication/SiApplication'))
const OwsiApplicationPage = lazy(() => import('../pages/Admin/OwsiApplication/OwsiApplication'))
const IeSchedulePage = lazy(() => import('../pages/Admin/IeSchedule'))
const EfriApplicationPage = lazy(() => import('../pages/Admin/EfriApplication/EfriApplication'))
const BasicMermaidApplicationPage = lazy(() => import('../pages/Admin/BasicMermaid/BasicMermaidApplication'))
const MermaidApplicationPage = lazy(() => import('../pages/Admin/Mermaid/MermaidApplication'))
const FDIAdminApplication = lazy(() => import('../pages/Admin/FDI/FDIApplication'))
const AFDIAdminApplication = lazy(() => import('../pages/Admin/AFDI/AFDIApplication'))
const MFDIAdminApplication = lazy(() => import('../pages/Admin/MFDI/MFDIApplication'))
const DSDAdminPage = lazy(() => import('../pages/Admin/DSD/DSD'))
const DMDAdminPage = lazy(() => import('../pages/Admin/DMD/DMD'))
const MergeCertsAdminPage = lazy(() => import('../pages/Admin/MergeCerts'))
const FindAccountAdminPage = lazy(() => import('../pages/Admin/FindAccount'))
const UpdateUserInfoPage = lazy(() => import('../pages/Admin/UpdateUserInfo'))
const AdminWenjuanListPage = lazy(() => import('../pages/Admin/Wenjuan'))
const OtherApplicationsAdminPage = lazy(() => import('../pages/Admin/otherApplications'))
const StoreApplicationsAdminPage = lazy(() => import('../pages/Admin/StoreApplications'))
const CreateOrderPage = lazy(() => import('../pages/Admin/TextbooksOrder/CreateOrder'))
const NonRoutineOrdersPage = lazy(() => import('../pages/Admin/TextbooksOrder/NonRoutineOrders'))
const TextbookOrdersPage = lazy(() => import('../pages/Admin/TextbooksOrder/TextbookOrders'))
const TextbookGoodsPage = lazy(() => import('../pages/Admin/TextbookGoods'))
const ApplicationFeeOrdersPage = lazy(() => import('../pages/Admin/TextbooksOrder/ApplicationFeeOrders'))
const InvoiceInfoPage = lazy(() => import('../pages/Admin/TextbooksOrder/InvoiceInfoOrders'))
const CustomizedImagesPage = lazy(() => import('../pages/Admin/CustomizedImages/CustomizedImagesPage'))
const MemberApplicationGoodPage = lazy(() => import('../pages/Admin/MemberApplicationGood/PriceMatrix'))
const RescueDrysuitAdminPage = lazy(() => import('../pages/Admin/RescueDrysuit'))
const RenewalPriceAdminPage = lazy(() => import('../pages/Admin/RenewalPrice'))
const CustomerServiceQueryPage = lazy(() => import('../pages/Admin/CustomerServiceQuery'))
const ElearningAgentPage = lazy(() => import('../pages/Admin/ElearningAgent'))
const RenewalOrderPage = lazy(() => import('../pages/Admin/RenewalOrder'))
const StoreDsdPage = lazy(() => import('../pages/Admin/StoreDsd'))
const DsdDashboardPage = lazy(() => import('../pages/Admin/DsdDashboard'))
const DsdStoreConfigPage = lazy(() => import('../pages/Admin/DsdStoreConfig'))
const CardLevelPage = lazy(() => import('../pages/Admin/CardLevel'))
const EcardGoodsPage = lazy(() => import('../pages/Admin/EcardGoods'))
const CardStockSortPage = lazy(() => import('../pages/Admin/CardStockSort'))
const CardFaceImagePage = lazy(() => import('../pages/Admin/CardFaceImage'))
const FuiouPaymentPage = lazy(() => import('../pages/Admin/FuiouPayment'))
const ProDirectoryAdminPage = lazy(() => import('../pages/Admin/ProDirectory'))
const EcardOrderPage = lazy(() => import('../pages/Admin/EcardOrder'))
const EcardOrderDetailPage = lazy(() => import('../pages/Admin/EcardOrder/Detail'))
const EcardCouponPage = lazy(() => import('../pages/Admin/EcardCoupon'))
const FuiouComplaintPage = lazy(() => import('../pages/Admin/FuiouComplaint'))
const FuiouComplaintDetailPage = lazy(() => import('../pages/Admin/FuiouComplaint/Detail'))

const PadiAdminRoutes = () => (
  <Suspense fallback={<div>Loading...</div>}>
    <ProtectedRoute path="/admin/dm" component={DmApplicationPage} admin={true} />
    <ProtectedRoute path="/admin/si" component={SiApplicationPage} admin={true} />
    <ProtectedRoute path="/admin/owsi" component={OwsiApplicationPage} admin={true} />
    <ProtectedRoute path="/admin/ie_schedule" component={IeSchedulePage} admin={true} />
    <ProtectedRoute path="/admin/efri" component={EfriApplicationPage} admin={true} />
    <ProtectedRoute path="/admin/basic_mermaid" component={BasicMermaidApplicationPage} admin={true} />
    <ProtectedRoute path="/admin/mermaid" component={MermaidApplicationPage} admin={true} />
    <ProtectedRoute path="/admin/fdi" component={FDIAdminApplication} admin={true} />
    <ProtectedRoute path="/admin/afdi" component={AFDIAdminApplication} admin={true} />
    <ProtectedRoute path="/admin/mfdi" component={MFDIAdminApplication} admin={true} />
    <ProtectedRoute path="/admin/dsd" component={DSDAdminPage} admin={true} />
    <ProtectedRoute path="/admin/dmd" component={DMDAdminPage} admin={true} />
    <ProtectedRoute path="/admin/collection/create" component={PicCollectionEditer} admin={true} />
    <ProtectedRoute path="/admin/collection/task_list" component={PicTasksList} admin={true} />
    <ProtectedRoute path="/admin/collection/task_detail_list" component={TaskPicList} admin={true} />
    <ProtectedRoute path="/admin/merge_certs" component={MergeCertsAdminPage} admin={true} />
    <ProtectedRoute path="/admin/find_account" component={FindAccountAdminPage} admin={true} />
    <ProtectedRoute path="/admin/update_user_info" component={UpdateUserInfoPage} admin={true} />
    <ProtectedRoute path="/admin/wenjuan" component={AdminWenjuanListPage} admin={true} />
    <ProtectedRoute path="/admin/pockets_apps" component={OtherApplicationsAdminPage} admin={true} />
    <ProtectedRoute path="/admin/store_apps" component={StoreApplicationsAdminPage} admin={true} />
    <ProtectedRoute path="/admin/create_order" component={CreateOrderPage} admin={true} />
    <ProtectedRoute path="/admin/non_routine_orders" component={NonRoutineOrdersPage} admin={true} />
    <ProtectedRoute path="/admin/textbook_orders" component={TextbookOrdersPage} admin={true} />
    <ProtectedRoute path="/admin/textbook_goods" component={TextbookGoodsPage} admin={true} />
    <ProtectedRoute path="/admin/application_fee_orders" component={ApplicationFeeOrdersPage} admin={true} />
    <ProtectedRoute path="/admin/invoice_info_orders" component={InvoiceInfoPage} admin={true} />
    <ProtectedRoute path="/admin/customized_images" component={CustomizedImagesPage} admin={true} />
    <ProtectedRoute path="/admin/member_application_good" component={MemberApplicationGoodPage} admin={true} />
    <ProtectedRoute path="/admin/rescue_drysuit" component={RescueDrysuitAdminPage} admin={true} />
    <ProtectedRoute path="/admin/renewal_price" component={RenewalPriceAdminPage} admin={true} />
    <ProtectedRoute path="/admin/customer_service_query" component={CustomerServiceQueryPage} admin={true} />
    <ProtectedRoute path="/admin/elearning_agent" component={ElearningAgentPage} admin={true} />
    <ProtectedRoute path="/admin/renewal_order" component={RenewalOrderPage} admin={true} />
    <ProtectedRoute path="/admin/store_dsd" component={StoreDsdPage} admin={true} />
    {/* CHNA-2659：看板页面免登录公开（业务决策 2026-07-24），供邮件收件人直开链接与 Playwright 截图；
        对应后端 summary/storeStats 两个只读接口已加鉴权白名单（resend 补发接口仍需登录）。
        保留 AdminContainer 布局：登录运营从菜单进入体验不变，未登录者点击其他菜单仍会被要求登录 */}
    <Route
      path="/admin/dsd_dashboard"
      render={(props) => (
        <AdminContainer>
          <DsdDashboardPage {...props} />
        </AdminContainer>
      )}
    />
    <ProtectedRoute path="/admin/dsd_store_config" component={DsdStoreConfigPage} admin={true} />
    <ProtectedRoute path="/admin/card_level" component={CardLevelPage} admin={true} />
    <ProtectedRoute path="/admin/ecard_goods" component={EcardGoodsPage} admin={true} />
    {/* CHNA-2775 电子卡面购买列表顺序：配置入口 2026-10-04 从 PHP 后台迁来（后端 /api/backstage/cardStockSort） */}
    <ProtectedRoute path="/admin/card_stock_sort" component={CardStockSortPage} admin={true} />
    {/* CHNA-2776 卡面图片管理：把生肖年卡面缺失的多语言图（-sc/-tc）摆出来并在后台直接补传 */}
    <ProtectedRoute path="/admin/card_face_image" component={CardFaceImagePage} admin={true} />
    <ProtectedRoute path="/admin/fuiou_payment" component={FuiouPaymentPage} admin={true} />
    <ProtectedRoute path="/admin/pro_directory" component={ProDirectoryAdminPage} admin={true} />
    {/* CHNA-2618 卡面订单：App 无 Switch 包裹，列表页必须 exact 避免与 /:id 前缀匹配同时渲染 */}
    <ProtectedRoute exact path="/admin/ecard_order" component={EcardOrderPage} admin={true} />
    <ProtectedRoute path="/admin/ecard_order/:id" component={EcardOrderDetailPage} admin={true} />
    {/* 券详情改弹窗后已无 /:id 页面：这里刻意不加 exact，让旧的 /admin/ecard_coupon/123 深链接回落到台账而非白屏 */}
    <ProtectedRoute path="/admin/ecard_coupon" component={EcardCouponPage} admin={true} />
    {/* CHNA-2752 富友投诉处理：详情是独立路由页（协商历史 + 证据图 + 四个动作表单），
        列表页同样必须 exact——App 无 Switch 包裹，否则 /:complaintId 会与列表同时渲染 */}
    <ProtectedRoute exact path="/admin/fuiou_complaint" component={FuiouComplaintPage} admin={true} />
    <ProtectedRoute path="/admin/fuiou_complaint/:complaintId" component={FuiouComplaintDetailPage} admin={true} />
  </Suspense>
)

export default PadiAdminRoutes
